import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CheckCircle2,
  Settings,
  AlertCircle,
  FileText
} from 'lucide-react';
import BotonVolver from './BotonVolver';
import BotonWhatsApp from './BotonWhatsApp';

export default function Rgstock() {
  const [t] = useTranslation("global");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-900 via-black to-zinc-900 text-zinc-100 font-sans selection:bg-zinc-500/30 pb-20">
      <BotonVolver text={t("rgstock.volver")} />

      <main className="relative">
        {/* Hero Section */}
        <section className="relative pt-32 pb-16 px-6 text-center">
          <div className="container mx-auto max-w-4xl">
            <h1 className="text-6xl md:text-7xl font-messina tracking-wide text-white mb-8 leading-tight">
              {t("rgstock.title")}
            </h1>
            <p className="text-xl md:text-2xl text-zinc-400 font-light mb-12 max-w-3xl mx-auto leading-relaxed italic">
              "{t("rgstock.subtitle")}"
            </p>
            <div className="flex justify-center items-center">
              <BotonWhatsApp
                text={t("rgstock.action-btn")}
                message="¡Hola! Me interesa obtener más información sobre RG Stock."
              />
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="py-10 px-6">
          <div className="container mx-auto max-w-4xl bg-zinc-900/30 border border-zinc-800/50 p-10 rounded-3xl text-center">
            <p className="text-lg md:text-xl text-zinc-300 font-light leading-relaxed">
              {t("rgstock.intro")}
            </p>
          </div>
        </section>

        {/* Features & Problems */}
        <section className="py-20 px-6">
          <div className="container mx-auto max-w-6xl grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Features */}
            <div className="space-y-8">
              <h2 className="text-3xl md:text-4xl font-messina tracking-wide text-white flex items-center gap-4">
                <Settings className="text-zinc-500" />
                {t("rgstock.features-title")}
              </h2>
              <div className="grid gap-4">
                {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                  <div key={num} className="flex items-center gap-4 p-4 bg-zinc-900/50 rounded-xl border border-zinc-800/50">
                    <CheckCircle2 className="text-zinc-500 w-5 h-5 flex-shrink-0" />
                    <span className="text-lg font-light text-zinc-300">{t(`rgstock.feature-${num}`)}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Problems */}
            <div className="space-y-8">
              <h2 className="text-3xl md:text-4xl font-messina tracking-wide text-white flex items-center gap-4">
                <AlertCircle className="text-zinc-500" />
                {t("rgstock.problems-title")}
              </h2>
              <div className="grid gap-4">
                {[1, 2, 3, 4, 5].map((num) => (
                  <div key={num} className="flex items-start gap-4 p-4 bg-zinc-900/20 rounded-xl border border-dashed border-zinc-800">
                    <div className="mt-1.5 w-1.5 h-1.5 bg-zinc-600 rounded-full flex-shrink-0" />
                    <span className="text-lg font-light text-zinc-400 italic">{t(`rgstock.problem-${num}`)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* AFIP Integration */}
        <section className="py-24 px-6">
          <div className="container mx-auto max-w-5xl overflow-hidden rounded-[3rem] border border-zinc-800 bg-gradient-to-br from-zinc-900 to-black p-12 md:p-20 relative">
            <div className="absolute top-0 right-0 p-10 opacity-5">
              <FileText size={200} />
            </div>
            <div className="relative z-10 text-center md:text-left">
              <h2 className="text-4xl font-messina tracking-wide text-white mb-8">
                {t("rgstock.afip-title")}
              </h2>
              <p className="text-xl text-zinc-400 font-light leading-relaxed mb-10 max-w-3xl">
                {t("rgstock.afip-text")}
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                {["Facturas A y B", "Tickets Electrónicos", "Validación Online", "Asociación de Clientes"].map((tag, i) => (
                  <span key={i} className="px-4 py-2 bg-zinc-800/50 rounded-full text-sm text-zinc-300 border border-zinc-700/50">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
